import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const messages = {
  ...zhLocale,
  "banner1": "Solplanet brand is a development of AISWEI",
  "banner2": "formerly SMA China",
  "banner3": "Solar for Everybody",
  "english": "English",
  "polish": "Polish",
  "spanish": "Spanish",
  "turkish": "Turkish",
  "germany": "德語",
  "french": "法語",
  "italian": "Italian",
  "systemData1": "System",
  "installationLocation1": "Installation",
  "customerData1": "Customer",
  "claimData": "Claim",
  "shippingAddress1": "Shipping",
  "customerData": "Customer / Client Data",
  "customerType": "Inquirer type",
  "selectCustomer": "Please select inquirer type",
  "--None--": "--None--",
  "Installer": "Installer",
  "End-customer": "End-customer",
  "Distributor": "Distributor",
  "EPC": "EPC",
  "Other": "Other",
  "companyName": "Company Name",
  "typeCompanyName": "Please enter company name",
  "contacts": "Contact name",
  "typeContacts": "Please enter contact name",
  "contactInformation": "Phone Number",
  "typeContactInformation": "Please enter Phone Number",
  "shippingAddress": "Shipping address(Please note that this address will serve as the shipping address in the case of an exchange.)",
  "country": "Country",
  "typeCountry": "Please enter country",
  "province": "State",
  "typeProvince": "Please enter state",
  "city": "City",
  "typeCity": "Please enter city",
  "area": "Street",
  "typeArea": "Please enter the full address (down to the house number)",
  "contacts01": "Mobile phone",
  "typeContacts01": "Please enter mobile phone",
  "postCode": "Postal Code",
  "typePostCode": "Please enter postal code",
  "email": "Email",
  "typeEmail": "Please enter email",
  "installationLocation": "Installation Location(use shipping address",
  "purchaseDate": "Purchase Date",
  "typePurchaseDate": "Please enter purchase date",
  "installDate": "Install Date",
  "typeInstallDate": "Please enter install date",
  "faultyDeviceType": "Faulty Device type",
  "InverterOther1": "001-LED lights off,but generate electricity",
  "InverterOther2": "002-LED lights off, no power output",
  "InverterOther3": "003-DC switch/Fuse/SPD damage",
  "InverterOther4": "004-AC connector/DC connector damage",
  "InverterOther5": "005-Low power generation",
  "InverterOther6": "006-Low power generation due to high temperature inside",
  "InverterOther7": "007-Loud  nosie",
  "InverterOther8": "008-One MPPT not working",
  "InverterOther9": "009-Unable to adjust the safety",
  "InverterOther10": "010-Inverter information empty",
  "InverterOther11": "011-Inverter data abnormal",
  "InverterOther12": "012-Inverter failed to be monitored",
  "InverterOther13": "013-Water flows into the inverter or inverter interior with water vapor",
  "InverterOther14": "014-Packing accessories shortage or missing",
  "InverterOther15": "015-Appearance problem",
  "InverterOther16": "016-Others",
  "inverterFault": "Inverter fault",
  "monitorFault": "Monitor fault",
  "selectFaultyDeviceType": "Please select faulty device type",
  "faultDate": "Fault Date",
  "typeFaultDate": "Please enter fault date",
  "deviceSerialNumber": "Device serial number",
  "typeDeviceSerialNumber": "Please enter device serial number",
  "faultySymptom": "Faulty symptom",
  "selectFaultySymptom": "Please select faulty symptom",
  "errorDescription": "Detailed error description",
  "typeErrorDescription": "Please type detailed error description",
  "purchaseFileId": "Purchase voucher (attachment)",
  "purchaseDesc": "The proof of purchase must include customer’s name, installation address, inverter model and the fact that it has been paid",
  "breakFileId": "Failure Certificate (attachment)",
  "breakDesc": "Please submit a photo of the defect detail, the error message and the product serial number sticker",
  "upload": "Upload",
  "systemData": "System Data (optional)",
  "systemData01": "Is it the first claim of this site?",
  "Yes": "Yes",
  "No": "No",
  "Unknown": "Unknown",
  "systemData02": "Other inverters operating status of the same site",
  "systemData03": "Reason for earlier claim",
  "enterSystemData03": "Please enter reason for earlier claim",
  "systemData04": "Fault detail of other inverters on the same site",
  "enterSystemData04": "Please enter fault detail of other inverters on the same site",
  "systemData05": "Inverter installation environmental conditions",
  "systemData0501": "Indoor",
  "systemData0502": "Outdoor(under the shaded site of the building or mount an awning)",
  "systemData0503": "Outdoor(exposing the inverter to direct sunlight)",
  "systemData0504": "Above water",
  "systemData0505": "Others",
  "systemData06": "Solar panels installation environmental conditions",
  "systemData0601": "On the ground",
  "systemData0602": "On the rooftop",
  "systemData0603": "On the water surface",
  "systemData0604": "Others",
  "systemData07": "Solar panel brand&model",
  "typeSystemData07": "Please enter solar panel brand&model",
  "systemData08": "PV mode",
  "systemData0801": "Independent",
  "systemData0802": "Parallel",
  "pleaseSelect": "Please select",
  "add": "Add",
  "delete": "Delete",
  "pv10": "string solar panel(pieces)",
  "pv101": "PV1string solar panel(pieces)",
  "pv102": "PV2string solar panel(pieces)",
  "pv103": "PV3string solar panel(pieces)",
  "pv104": "PV4string solar panel(pieces)",
  "circuit01": "open circuit voltage(V)",
  "alternatingVoltage": "Alternating Voltage",
  "l1l2": "AC voltage L1 - L2(V)",
  "l1n": "AC voltage L1 - N(V)",
  "l2l3": "AC voltage L2 - L3(V)",
  "l2n": "AC voltage L2 - N(V)",
  "l1l3": "AC voltage L1 - L3(V)",
  "l3n": "AC voltage L3 - N(V)",
  "l1pe": "AC voltage L1 - PE(V)",
  "l3pe": "AC voltage L3 - PE(V)",
  "l2pe": "AC voltage L2 - PE(V)",
  "npe": "AC voltage N - PE(V)",
  "complaintFileId": "Attachment",
  "activeTip": "Notice：The more detail installation information you can provide, the quicker we can identify the problem.",
  "submitBtn": "Submit",
  "pleaseType": "Please enter",
  "submitSuccess": "Submit success",
  "submitDesc": "Some required fields are not filled in, please resubmit after confirmation. Thank you!",
  "typeUpload": "Please upload",
  "resetUpload": "Reupload",
  "selectErrorMessage": "Please select error message",
  "errorMessage": "Other",
  "MPPT": "MPPT",
  "chinese": "Chinese",
  "dutch": "Dutch",
  "hungary": "hungary",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "同意并愿意遵守爱士惟新能源技术隐私条款",
  "iagree": "同意并愿意遵守爱士惟新能源技术隐私条款",
  "language": "语言",
  "ptbr": "葡萄牙语 (巴西)",
  "zhtw": "繁体中文",
  "documentTitle": "质保 │爱士惟",
  "validateNumber": "請輸入一個整數"
}
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/zh.js